import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';

import type { ReservationListItems } from 'ReservationList-Types';

import type { ReservationListState } from './reducer';

export const getItems = (state: RootState) => state.reservationList.items;
export const getErrors = (state: RootState) => state.reservationList.errors;

export const getReservationList = (state: RootState) => state.reservationList;

export const getSelectedStatusType = (state: RootState) => state.reservationList.selectedStatusType;

export const getIsFetching = createSelector(
  getReservationList,
  (state: ReservationListState) => state.isFetching,
);

export const getIsFetchingMore = createSelector(
  getReservationList,
  (state: ReservationListState) => state.isFetchingMore,
);

export const getDestinationCount = createSelector(getItems, (state: ReservationListItems) => {
  return (
    (state.reservations || []).reduce(
      (acc, reservation) => {
        const country = reservation.provider.areaInfo?.country;
        if (country) {
          acc[country] = (acc[country] || 0) + 1;
        }
        return acc;
      },
      {} as { [key: string]: number },
    ) || {}
  );
});
